import React from 'react'
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Chip,
    Box,
    useTheme,
} from '@material-ui/core'
import { useUserTags } from '../../../contexts/UserTagsContext'

interface Props {
    selectedTagIds: number[]
    onChange: (tagIds: number[]) => void
    minWidth?: number
}

export const ProjectTagFilterSelect: React.FC<Props> = ({
    selectedTagIds,
    onChange,
    minWidth = 200,
}) => {
    const theme = useTheme()
    const { userTags, loading: tagsLoading } = useUserTags()

    return (
        <FormControl variant="outlined" size="small" style={{ minWidth }}>
            <InputLabel>Filter by Tags</InputLabel>
            <Select
                multiple
                value={selectedTagIds}
                onChange={(e) => onChange(e.target.value as number[])}
                label="Filter by Tags"
                renderValue={(selected) => (
                    <Box
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 4,
                        }}
                    >
                        {(selected as number[]).map((tagId) => {
                            const tag = userTags.find((t) => t.id === tagId)
                            return tag ? (
                                <Chip
                                    key={tagId}
                                    label={tag.name}
                                    size="small"
                                    style={{
                                        backgroundColor: tag.color,
                                        color: 'white',
                                    }}
                                />
                            ) : null
                        })}
                    </Box>
                )}
                disabled={tagsLoading}
            >
                {userTags.map((tag) => (
                    <MenuItem key={tag.id} value={tag.id}>
                        <Chip
                            label={tag.name}
                            size="small"
                            style={{
                                backgroundColor: tag.color,
                                color: 'white',
                                marginRight: theme.spacing(1),
                            }}
                        />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
